export default "__VITE_ASSET__t5WRMwan__"